import { ResizableBox } from 'react-resizable';
import {useEffect, useRef, useState} from "react";
import constants from '../../../../../../../config/constants';

function EditNoteItem(props: any) {
    const { onResizeLeft, onResizeRight,  onResizeLeftStop, onResizeRightStop, children, style, editNoteContainerWidth, noteMinWidth, startXPosition, endXPosition } = props;
    // const wrapperLeftBoundary = useMemo(() => startXPosition, [startXPosition]);
    // const wrapperRightBoundary = useMemo(() => editNoteWidth - startXPosition - 100, [editNoteWidth, startXPosition]);

    const [wrapperLeftBoundary, setWrapperLeftBoundary] = useState(0);
    const [wrapperRightBoundary, setWrapperRightBoundary] = useState(editNoteContainerWidth);

    useEffect(() => {
        setWrapperLeftBoundary(editNoteContainerWidth - (endXPosition + noteMinWidth));
    }, [endXPosition, editNoteContainerWidth, noteMinWidth]);

    useEffect(() => {
        setWrapperRightBoundary(editNoteContainerWidth - (startXPosition + noteMinWidth ));
    }, [startXPosition, editNoteContainerWidth, noteMinWidth]);

    const  contentRef: any = useRef();

    const onLeftStop = (e: any) => {
        onResizeLeftStop(e);
        if (!contentRef.current)    return;

        setWrapperRightBoundary(editNoteContainerWidth - (contentRef.current.offsetLeft + noteMinWidth ));
    }

    const onRightStop = (e: any) => {
        onResizeRightStop(e);
        if (!contentRef.current)    return;

        setWrapperLeftBoundary(contentRef.current.offsetLeft + contentRef.current.offsetWidth - noteMinWidth);
    }

    return (
        <div style={style}>
            <ResizableBox
                className={props.wrapperClass1}
                width={startXPosition}
                height={0}
                maxConstraints={[wrapperLeftBoundary, 0]}
                minConstraints={[0,0]}
                resizeHandles={['e']}
                onResize={(e) => onResizeLeft(e)}
                onResizeStop={(e) => onLeftStop(e)}>
            </ResizableBox>

            <div
                style={{flex: 1, minWidth: constants.ANALYZE.AGENDA_MIN_WIDTH}}
                ref={contentRef}
                >
                {children}
            </div>

            <ResizableBox
                className={props.wrapperClass2}
                width={endXPosition}
                height={0}
                maxConstraints={[wrapperRightBoundary, 0]}
                minConstraints={[0,0]}
                resizeHandles={['w']}
                onResize={(e) => onResizeRight(e)}
                onResizeStop={(e) => onRightStop(e)}>
            </ResizableBox>

        </div>
    )
}

export default EditNoteItem;